export const SERVICE_TYPES = {
  LESSON: 'lesson',
  TRAINING: 'training',
  RENT: 'rent',
  GROUP: 'group',
};

export const SERVICE_TYPES_UA = {
  [SERVICE_TYPES.LESSON]: 'Індивідуальне заняття',
  [SERVICE_TYPES.TRAINING]: 'Самостійне тренування',
  [SERVICE_TYPES.RENT]: 'Оренда залу',
  [SERVICE_TYPES.GROUP]: 'Групове заняття',
};
